import { render } from "./hr-co-icon.vue?vue&type=template&id=c062dbd2&scoped=true"
import script from "./hr-co-icon.vue?vue&type=script&lang=js"
export * from "./hr-co-icon.vue?vue&type=script&lang=js"

import "./hr-co-icon.vue?vue&type=style&index=0&id=c062dbd2&scoped=true&lang=css"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c062dbd2"]])

export default __exports__